goog.module('yext.m4.confcode.adminconsole.modal.SettingsModal');

const {Checkbox} = goog.require('yext.ui.components.Checkbox');
const {SmallDialog} = goog.require('yext.ui.components.modal.Dialog');
goog.require('yext');

/**
 * @fileoverview Component that renders the settings modal.
 *
 * @author Benjamin Leitner (bleitner@yext.com)
 */
class SettingsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDialog: props.showDialog,
      isInFriendlyNameMode: props.isInFriendlyNameMode,
      shouldShowReadOnlyResources: props.shouldShowReadOnlyResources,
      isInResourceTypeMode: props.isInResourceTypeMode,
    };

    this.onHideDialog = this.onHideDialog.bind(this);
    this.onSaveCallback = this.onSaveCallback.bind(this);
  }

  onHideDialog() {
    this.setState({showDialog: false});
  }

  onSaveCallback() {
    const {isInFriendlyNameMode, shouldShowReadOnlyResources, isInResourceTypeMode} = this.state;
    this.props.onSave(isInFriendlyNameMode, shouldShowReadOnlyResources, isInResourceTypeMode);
    this.setState({showDialog: false});
  }

  // TODO (bleitner): If sidebar.js is ever changed to be a react component, pull this code out to
  //                 sidebar.js. The state should just be maintained in sidebar.js
  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      this.setState({showDialog: this.props.showDialog});
    }
  }

  render() {
    const {isInFriendlyNameMode, shouldShowReadOnlyResources, isInResourceTypeMode} = this.state;
    const callToAction = {
      primary: {
        type: 'active',
        text: yext.msg('Save'),
        callback: this.onSaveCallback,
      },
      cancel: {
        type: 'cancel',
        text: yext.msg('Cancel'),
      },
    };

    return (
      <SmallDialog
        title="Settings"
        callToAction={callToAction}
        show={this.state.showDialog}
        onHideDialog={this.onHideDialog}
      >
        <Checkbox
          id="isInFriendlyNameMode"
          label="Friendly Name Mode"
          checked={isInFriendlyNameMode}
          helpText="Show friendly identifiers for resource file names"
          value="isInFriendlyNameMode"
          onChange={() => this.setState({isInFriendlyNameMode: !isInFriendlyNameMode})}
        ></Checkbox>
        <Checkbox
          id="shouldShowReadOnlyResources"
          label="Show Read-Only Resources"
          checked={shouldShowReadOnlyResources}
          helpText="Show read-only resources, in addition to configurable resources"
          value="shouldShowReadOnlyResources"
          onChange={() =>
            this.setState({shouldShowReadOnlyResources: !shouldShowReadOnlyResources})
          }
        ></Checkbox>
        <Checkbox
          id="isInResourceTypeMode"
          label="Resource Type Mode"
          checked={isInResourceTypeMode}
          helpText="Display resource groups as top level directories, rather than namespaces."
          value="isInResourceTypeMode"
          onChange={() => this.setState({isInResourceTypeMode: !isInResourceTypeMode})}
        />
      </SmallDialog>
    );
  }
}

SettingsModal.propTypes = {
  showDialog: PropTypes.bool,
  isInFriendlyNameMode: PropTypes.bool,
  shouldShowReadOnlyResources: PropTypes.bool,
  isInResourceTypeMode: PropTypes.bool,
  onSave: PropTypes.func,
};

SettingsModal.defaultProps = {
  showDialog: false,
  isInFriendlyNameMode: false,
  shouldShowReadOnlyResources: false,
  isInResourceTypeMode: false,
  onSave: () => {},
};

SettingsModal['defaultProps'] = SettingsModal.defaultProps;
SettingsModal['propTypes'] = SettingsModal.propTypes;

exports = SettingsModal;
